import styles from './Redactor.module.scss'
import {useState} from "react";
import MonacoEditor from '@monaco-editor/react';
import {template} from "../ListWithRedactor/ListWithRedactor";
export type RedactorProps = {
    id:number
    name:string
    htmlCode:string
    jsonCode:string
    renderedHtml:string
    setRenderedHtml:(value:string)=>void
    token:string
    setAuthState:(value:boolean|null)=>void
    setId:(value:number)=>void
    setTemplateName:(value:string)=>void
    setHtmlCode:(value:string)=>void
    setJson:(value:string)=>void
    setTemplateList:(value:template[])=>void
    templateList:template[]
    showDemo:(html:string)=>void
}
export default function Redactor(props:RedactorProps){
    const [errorText, setErrorText] = useState<string>('')
    const validate = ()=>{
        try {
            if(props.htmlCode.length===0 || props.name.length===0){
                setErrorText('не все поля заполнены')
                return
            }
            let example = JSON.parse(props.jsonCode)
            if(typeof example !== "object"){
                setErrorText('json должен быть объектом')
                return
            }
            fetch(process.env.REACT_APP_BASE_URL+'/ValidateTemplate',{
                method:'POST',
                headers:{
                  "Authorization":props.token
                },
                body:JSON.stringify({
                    id:0,
                    name:props.name,
                    pattern:props.htmlCode,
                    dataExample:example
                })
            }).then(async (result)=>{
                return {
                    status: result.status,
                    data: await result.json()
                }
            }).then((response:{status:number,data:{message:string}})=>{
                if(response.status===200){
                    props.showDemo(response.data.message)
                } else {
                    if (response.status===403){
                        props.setAuthState(false)
                    } else {
                        setErrorText(response.data.message)
                    }
                }
            }).catch((e)=>setErrorText(String(e)))
        } catch (e) {
            setErrorText(String(e))
        }
    }
    const saveTemplate = ()=>{
        try {
            if(props.htmlCode.length===0 || props.name.length===0 || props.jsonCode.length===0){
                setErrorText('не все поля заполнены')
                return
            }
            let example = JSON.parse(props.jsonCode)
            if(typeof example !== "object"){
                setErrorText('json должен быть объектом')
                return
            }
            fetch(process.env.REACT_APP_BASE_URL+'/SaveTemplate',{
                method:'POST',
                headers:{
                    "Authorization":props.token
                },
                body:JSON.stringify({
                    id:props.id,
                    name:props.name,
                    pattern:props.htmlCode,
                    dataExample:example
                })
            }).then(async (result)=>{
                return {
                    status: result.status,
                    data: await result.json()
                }
            }).then((response)=>{
                if(response.status===200){
                    let newTemplateList = props.templateList
                    let index = newTemplateList.findIndex(item=>item.id===props.id)
                    let newTemplate:template = {
                        id:response.data.message.id,
                        renderedTemplate:(response.data.message.renderedExample),
                        jsonExample:JSON.parse(props.jsonCode),
                        name:props.name,
                        pattern:props.htmlCode
                    }
                    if(index>=0){
                        newTemplateList[index]=newTemplate
                    } else {
                        newTemplateList.push(newTemplate)
                    }
                    props.setTemplateList(newTemplateList)
                    props.setHtmlCode('')
                    props.setJson('')
                    props.setTemplateName('')
                    props.setId(0)
                    setErrorText('')
                } else {
                    if (response.status===403){
                        props.setAuthState(false)
                    } else {
                        setErrorText(response.data.message)
                    }
                }
            }).catch((e)=>setErrorText(String(e)))
        } catch (e) {
            setErrorText(String(e))
        }
    }
    return (
        <div className={styles.RedactorContainer}>
            <input type="text"
                   className={styles.NameInput}
                   placeholder={"Введите имя шаблона"}
                   value={props.name}
                   onChange={(evn) => {
                       setErrorText('')
                       props.setTemplateName(evn.target.value)
                   }}/>
            <div className={styles.Subtitle}>Редактор шаблона №{props.id}</div>
            <div className={styles.EditorContainer}>
                <MonacoEditor
                    language="html"
                    theme="vs-dark"
                    value={props.htmlCode}
                    onChange={(e,v)=> {
                        setErrorText('')
                        //@ts-ignore
                        props.setHtmlCode(e)
                    }}
                    height={300}
                />
            </div>
            <div className={styles.Subtitle}>Редактор образцового JSON</div>
            <div className={styles.EditorContainer}>
                <MonacoEditor
                    language="json"
                    theme="vs-dark"
                    value={props.jsonCode}
                    onChange={(e,v)=> {
                        setErrorText('')
                        //@ts-ignore
                        props.setJson(e)
                    }}
                    height={300}
                />
            </div>
            <div className={styles.ErrorText}>{errorText}</div>
            <button className={styles.ActionButton} onClick={validate}>Протестировать шаблон</button>
            <button className={styles.ActionButton} onClick={saveTemplate}>{props.id!=0 ? "Сохранить изменения в шаблоне":"Добавить шаблон"}</button>
            {props.id !== 0 ? <button className={styles.ActionButton} onClick={() => {
                props.setId(0)
                props.setJson('{}')
                props.setTemplateName('')
                props.setHtmlCode('')
                props.setRenderedHtml('')
                setErrorText('')
            }}>Вернуться в режим создания</button> : null}
        </div>
    );
}